import React, { useState } from 'react';
import Styled from '../styles/AdminFVContainer.styled';
import StyledForm from '../styles/FormFV.styled';
import { MdClose } from 'react-icons/md';
import Colors from 'enums/Colors';
import ReactQuill from 'react-quill';
import { Input, Select, Switch } from 'antd';
import { IFormFVContainer } from '../interfaces/components/IFormFVContainer';
import ImagemPreviewFerramentaVideo from './ImagemPreviewFerramentaVideo';
import * as Yup from 'yup';
import { LoadingSpinner } from 'components/loadings/LoadingSpinner';
import { IFormFVRole } from '../interfaces/components/IFormFVRole';
import useFetch from 'hooks/useFetch';
import { CategoriaPEService } from 'core/http/service/acessosExclusivos/CategoriaPE.service';
import CategoriaPE from 'models/acessoExclusivo/CategoriaPE';

const serviceCategorys = new CategoriaPEService();

// Schema de validação Yup
const validationSchema = Yup.object().shape({
    categorias: Yup.array().min(1, 'Selecione pelo menos uma categoria').required('Categorias são obrigatórias'),
    // outros campos se necessário
});

const FormFVRole = ({ formVisible, handleSubmit, setForm, setFormVisible, form, handleChange, loading }: IFormFVRole) => {
    const [categories, setCategories] = useState<CategoriaPE[]>([]);
    const [base64, setBase64] = useState<string | null>(null);

    // Add a handler that matches the expected signature for onResetBase64
    const handleResetBase64 = () => {
        setForm((prev: any) => ({ ...prev, capaBase64: null, capaFilepath: null }));
        setBase64(null);
    };

    // Estado para erros de validação
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    // Novo handler para submit que valida com Yup antes de submeter
    const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            await validationSchema.validate(form, { abortEarly: false });
            setErrors({});
            handleResetBase64();
            handleSubmit(e);
        } catch (err: any) {
            if (err.inner) {
                const formErrors: { [key: string]: string } = {};
                err.inner.forEach((validationError: any) => {
                    if (validationError.path && !formErrors[validationError.path]) {
                        formErrors[validationError.path] = validationError.message;
                    }
                });
                setErrors(formErrors);
            }
        }
    };

    useFetch(() => {
        const fetchData = async () => {
            const { data, status } = await serviceCategorys.listAll();

            if (status === 200 && data && Array.isArray(data)) {
                setCategories(data.map((categoria: any) => CategoriaPE.fromJSON(categoria)));
            }
        };
        fetchData();
    }, []);

    return (
        <StyledForm.FormPackage onSubmit={handleFormSubmit} active={formVisible} style={{ gridTemplateColumns: '1fr' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="title">Title</Styled.Label>
                    <Input
                        id="title"
                        name="title"
                        size='large'
                        placeholder='Título da Regra'
                        value={form.title}
                        onChange={e => setForm((prev: any) => ({ ...prev, title: e.target.value }))}
                    />

                    {errors.title && <div style={{ color: 'red', fontSize: 12 }}>{errors.title}</div>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="categoria">Categoria</Styled.Label>
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Categorias exclusivas"
                        size="large"
                        value={form.categorias}
                        onChange={v => setForm((prev: any) => ({ ...prev, categorias: v }))}
                        options={categories.map((c: any) => ({ label: c.nome, value: c.id }))}
                    />

                    {errors.categorias && <div style={{ color: 'red', fontSize: 12 }}>{errors.categorias}</div>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="description">Descrição</Styled.Label>
                    <ReactQuill
                        value={form.description}
                        onChange={v => {
                            setForm((prev: any) => ({ ...prev, description: v }));
                        }}
                        placeholder="Digite a descrição"
                        style={{
                            backgroundColor: 'white',
                            color: 'black',
                        }}
                    />
                </Styled.FormGroup>

                <Styled.FormGroup>
                    <Styled.Label htmlFor="default">Regra padrão? Apresentar mesmo com usuário deslogado?</Styled.Label>
                    <Switch
                        checked={form.defaultRole}
                        onChange={checked => setForm((prev: any) => ({ ...prev, defaultRole: checked }))}
                        style={{ width: 40 }}
                    />
                </Styled.FormGroup>
            </div>

            <MdClose
                style={{ cursor: 'pointer', position: 'absolute', top: 10, right: 10 }}
                size={32}
                color={Colors.Blue}
                onClick={() => setFormVisible(false)}
            />
            <Styled.FormGroup>
                <Styled.Label htmlFor="tags">Imagem da Regua</Styled.Label>
                <ImagemPreviewFerramentaVideo
                    filepath={form.filePathRegua}
                    resetForm={handleResetBase64}
                    onBase64Change={base64 => setForm((prev: any) => ({ ...prev, base64: base64 }))}
                    styles={{ minHeight: '115px', height: '115px', maxHeight: '115px' }}
                    base64={base64 ?? ''}
                    setBase64={setBase64}
                />
            </Styled.FormGroup>
            <Styled.Button type="submit"> {loading ? <div className='loaderConteudo' style={{width: "26px"}}/> : form.id > 0 ? 'Atualizar Regra' : 'Criar Regra'} </Styled.Button>
           
        </StyledForm.FormPackage>
    );
};

export default FormFVRole;
